export default function isSeatChosen({ chosenSeats, seat, wagonNumber }) {
  return chosenSeats?.find(
    (chosenSeat) => JSON.stringify({
      seat_number: chosenSeat?.seat_number,
      wagon_number: chosenSeat?.wagon_number,
    })
            === JSON.stringify({
              seat_number: seat?.seat_number,
              wagon_number: wagonNumber,
            }),
  );
}
